<div class="d-flex flex-column">
  <div *ngIf="proposal.partner.name" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.partnerName' | translate}}:</div>
    <div>{{proposal.partner.name}}</div>
  </div>
  <div *ngIf="proposal.partner.street ||
              proposal.partner.houseNumber ||
              proposal.partner.addressSupplement" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.streetNumber' | translate}}:</div>
    <div>{{proposal.partner.street}}
      {{proposal.partner.houseNumber}}
      <div *ngIf="proposal.partner.addressSupplement">
        , {{proposal.partner.addressSupplement}}
      </div>
    </div>
  </div>
  <div *ngIf="proposal.partner.postalCode || proposal.partner.location" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.zipLocation' | translate}}:</div>
    <div>
      <div>{{proposal.partner.postalCode}} {{proposal.partner.location}}</div>
    </div>

  </div>

  <div *ngIf="proposal.partner.countryCode" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:</div>
    <div>
      <div>{{proposal.partner.countryCode}},
        {{'countryCodes.' + proposal.partner.countryCode |translate }}</div>
    </div>
  </div>
</div>
